import { api } from '@/fsd/shared/api';
import { IApiPaginatedResponse } from '@/fsd/shared/api/types';
import { IGeneralStockFilers } from '../model/types/IGeneralStockFilers';
import { IPostGeneralStocksResult } from '../model/types/IPostGeneralStocksResult';

interface IParams {
  filters: IGeneralStockFilers;
  page: number;
  limit: number;
}

export const postGeneralStocks = async (requestBody: IParams) => {
  const result = await api.post<
    IApiPaginatedResponse<IPostGeneralStocksResult>
  >(`/api/v1/general/stocks/`, {
    body: {
      ...requestBody,
      filters: {
        ...requestBody.filters,
        barcodes: requestBody.filters.barcodes
          ? [requestBody.filters.barcodes]
          : undefined,
        supplier_articles: requestBody.filters.supplier_articles
          ? [requestBody.filters.supplier_articles]
          : undefined,
      },
    },
  });

  return result;
};
